export enum KamiVisibility {
  CLIENT,
  ADMIN,
  MARKETING
}